import React, { Component } from 'react';
import { Table, Tooltip, Popover, Tag, Modal, Input, Button, message, Spin, Pagination, Image } from 'antd';
import { SearchOutlined, SendOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import { buildShortProductImageUrl, parseShortProductImages } from '../../utils/shortProductImages';

const cookies = new Cookies();

class ShortProductTable extends Component {

    state = {
        loading: false,
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: 0,

        // 回复邮件弹窗
        replyModalVisible: false,
        replyProductId: null,
        replyMessageId: '',
        replyBody: '',
        replyImagePaths: [],
        replySending: false,

        // 邮件预览弹窗
        previewModalVisible: false,
        previewMail: null,
        previewLoading: false,

        // 匹配中的产品ID
        matchingId: null,
    }

    componentDidMount() {
        this.fetchList(1);
    }

    getToken = () => cookies.get('token')

    fetchList = (page) => {
        this.setState({ loading: true });
        axios.get(window.api + 'short-product/list?page=' + page + '&token=' + this.getToken())
            .then((response) => {
                this.setState({
                    data: response.data.data,
                    currentPage: response.data.current_page,
                    lastPage: response.data.last_page,
                    total: response.data.total,
                    loading: false,
                });
            })
            .catch((error) => {
                message.error('加载失败');
                this.setState({ loading: false });
            });
    }

    // 匹配邮件
    handleMatchMail = (record) => {
        this.setState({ matchingId: record.id });
        axios.post(window.api + 'short-product/' + record.id + '/match-mail?token=' + this.getToken())
            .then((response) => {
                if (response.data.mail) {
                    message.success('已匹配到邮件');
                } else {
                    message.warning(response.data.messages || '未找到匹配邮件');
                }
                this.setState({ matchingId: null });
                this.fetchList(this.state.currentPage);
            })
            .catch((error) => {
                message.error(error.response?.data?.errors || '匹配失败');
                this.setState({ matchingId: null });
            });
    }

    // 邮件预览
    handlePreviewMail = (record) => {
        if (!record.ab) {
            message.warning('该订单没有AB号');
            return;
        }
        this.setState({ previewModalVisible: true, previewLoading: true, previewMail: null });
        axios.post(window.api + 'short-product/mail/search?token=' + this.getToken(), {
            keyword: record.ab,
        })
            .then((response) => {
                this.setState({
                    previewMail: response.data.mail,
                    previewLoading: false,
                });
            })
            .catch((error) => {
                message.error('加载邮件失败');
                this.setState({ previewLoading: false });
            });
    }

    // 生成回复模板
    buildReplyTemplate = (record) => {
        const ab = record.ab || '___';
        const brand = record.brand_name || '';
        const name = record.product_name || '';
        const ordered = record.amount || 0;
        const delivered = record.delivered_quantity || 0;
        const shortage = ordered - delivered;

        return `Sehr geehrte Damen und Herren,\n\n\nbei der Lieferung ${ab} haben wir folgende Fehlmenge festgestellt:\n· ${brand} ${name}– bestellt: ${ordered} Stück, geliefert: ${delivered} Stück → Fehlmenge: ${shortage} Stück (siehe beigefügte Fotos)\n\n\nBitte prüfen Sie diesen Vorgang und teilen Sie uns mit, wann wir die fehlenden Artikel erhalten werden.\nVielen Dank für Ihre Unterstützung. Wir freuen uns auf Ihre zeitnahe Rückmeldung.\nMit freundlichen Grüßen\n\n\n\n\nAOI Support Team \n\nTel.:  +49 40 181009210\nFax: +49 40 18234891\nE-mail:  al.yin@aoi-solutions.com\nUnsere neue Anschrift lautet: \nAOI Solutions GmbH \nArchenholzstraße 78 \n22117 Hamburg \nSteuernummer: 43/703/01021 | USt-ID-Nr.: DE298769153 | Registerblatt: HRB135388`;
    }

    // 打开回复弹窗
    showReplyModal = (record) => {
        if (!record.short_mail_id) {
            message.warning('请先匹配邮件');
            return;
        }
        const images = parseShortProductImages(record.short_images);
        this.setState({
            replyModalVisible: true,
            replyProductId: record.id,
            replyMessageId: record.short_mail_id,
            replyBody: this.buildReplyTemplate(record),
            replyImagePaths: images,
        });
    }

    // 发送回复
    handleReply = () => {
        const { replyProductId, replyMessageId, replyBody, replyImagePaths } = this.state;
        if (!replyBody.trim()) {
            message.warning('请输入回复内容');
            return;
        }

        this.setState({ replySending: true });
        axios.post(window.api + 'short-product/mail/reply?token=' + this.getToken(), {
            product_id: replyProductId,
            message_id: replyMessageId,
            body: replyBody,
            images: replyImagePaths,
        })
            .then(() => {
                message.success('回复成功');
                this.setState({ replyModalVisible: false, replySending: false });
                this.fetchList(this.state.currentPage);
            })
            .catch((error) => {
                message.error(error.response?.data?.errors || '回复失败');
                this.setState({ replySending: false });
                this.fetchList(this.state.currentPage);
            });
    }

    renderMailStatus = (status) => {
        switch (status) {
            case 0: return <Tag>未回复</Tag>;
            case 1: return <Tag color="success">已回复</Tag>;
            case 2: return <Tag color="error">发送失败</Tag>;
            default: return <Tag>未回复</Tag>;
        }
    }

    render() {
        const { loading, data, total, currentPage } = this.state;
        const token = this.getToken();

        const columns = [
            {
                title: '#',
                key: 'index',
                width: 40,
                render: (_, __, idx) => (currentPage - 1) * 50 + idx + 1,
            },
            {
                title: '产品',
                key: 'product',
                width: 160,
                render: (_, record) => (
                    <>
                        <span>{record.brand_name}</span><br />
                        <span>{record.product_name}</span>
                    </>
                ),
            },
            {
                title: '数量',
                key: 'quantity',
                width: 90,
                render: (_, record) => {
                    const amount = record.amount || 0;
                    const delivered = record.delivered_quantity || 0;
                    const shortage = amount - delivered;
                    return (
                        <>
                            <span>{amount} - {delivered}</span>
                            <span style={{ color: '#f5222d' }}> = {shortage}</span>
                        </>
                    );
                },
            },
            {
                title: '图片',
                key: 'short_images',
                width: 120,
                render: (_, record) => {
                    const images = parseShortProductImages(record.short_images);
                    if (!images.length) return <span style={{ color: '#999' }}>-</span>;
                    return (
                        <Image.PreviewGroup>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                {images.map((url, i) => (
                                    <Image
                                        key={i}
                                        src={buildShortProductImageUrl(url)}
                                        width={36}
                                        height={36}
                                        style={{ objectFit: 'cover', borderRadius: '3px', border: '1px solid #d9d9d9' }}
                                        preview={{ src: buildShortProductImageUrl(url) }}
                                    />
                                ))}
                            </div>
                        </Image.PreviewGroup>
                    );
                },
            },
            {
                title: '标记时间',
                dataIndex: 'short_at',
                key: 'short_at',
                width: 120,
                render: (val) => val ? val.substring(0, 16) : '',
            },
            {
                title: '订单号',
                key: 'order_name',
                width: 100,
                render: (_, record) => (
                    <Link to={'/order/' + record.order_id} target="_blank">
                        {record.order_name}
                    </Link>
                ),
            },
            {
                title: 'AB号',
                dataIndex: 'ab',
                key: 'ab',
                width: 100,
            },
            {
                title: '标记人',
                dataIndex: 'short_by_name',
                key: 'short_by_name',
                width: 70,
            },
            {
                title: '匹配到的邮件',
                key: 'mail',
                width: 180,
                render: (_, record) => {
                    if (record.short_mail_subject) {
                        return (
                            <Popover
                                title={record.short_mail_subject}
                                content={
                                    <div style={{ maxWidth: 400, maxHeight: 300, overflow: 'auto', whiteSpace: 'pre-wrap', fontSize: 12 }}>
                                        {record.short_mail_body_preview}
                                    </div>
                                }
                                trigger="hover"
                            >
                                <span style={{ cursor: 'pointer', color: '#1890ff', textDecoration: 'underline' }}>
                                    {record.short_mail_subject.length > 30
                                        ? record.short_mail_subject.substring(0, 30) + '...'
                                        : record.short_mail_subject}
                                </span>
                            </Popover>
                        );
                    }
                    return (
                        <Button
                            size="small"
                            icon={<SearchOutlined />}
                            loading={this.state.matchingId === record.id}
                            onClick={() => this.handleMatchMail(record)}
                            disabled={!record.ab}
                        >
                            匹配邮件
                        </Button>
                    );
                },
            },
            {
                title: '回复预览',
                key: 'reply_preview',
                width: 80,
                render: (_, record) => {
                    if (record.short_reply_body) {
                        return (
                            <Popover
                                title="回复内容"
                                content={
                                    <div style={{ maxWidth: 400, maxHeight: 200, overflow: 'auto', whiteSpace: 'pre-wrap', fontSize: 12 }}>
                                        {record.short_reply_body}
                                        {record.short_reply_at && <div style={{ marginTop: 8, color: '#999' }}>回复于: {record.short_reply_at}</div>}
                                    </div>
                                }
                                trigger="hover"
                            >
                                <Button size="small" icon={<EyeOutlined />}>查看</Button>
                            </Popover>
                        );
                    }
                    return <span style={{ color: '#999' }}>-</span>;
                },
            },
            {
                title: '回复',
                key: 'reply',
                width: 70,
                render: (_, record) => (
                    <Button
                        size="small"
                        icon={<SendOutlined />}
                        type={record.short_mail_id ? 'primary' : 'default'}
                        disabled={!record.short_mail_id}
                        onClick={() => this.showReplyModal(record)}
                    >
                        回复
                    </Button>
                ),
            },
            {
                title: '状态',
                key: 'status',
                width: 70,
                render: (_, record) => this.renderMailStatus(record.short_mail_status),
            },
        ];

        return (
            <>
                <Spin spinning={loading}>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        pagination={false}
                        size="small"
                        bordered
                        scroll={{ x: 1220 }}
                    />
                </Spin>

                {total > 50 && (
                    <div style={{ textAlign: 'center', marginTop: 16 }}>
                        <Pagination
                            current={currentPage}
                            total={total}
                            pageSize={50}
                            onChange={(page) => this.fetchList(page)}
                            showTotal={(total) => `共 ${total} 条`}
                        />
                    </div>
                )}

                {/* 回复邮件弹窗 */}
                <Modal
                    title="回复邮件"
                    open={this.state.replyModalVisible}
                    onOk={this.handleReply}
                    onCancel={() => this.setState({ replyModalVisible: false })}
                    okText="发送回复"
                    cancelText="取消"
                    confirmLoading={this.state.replySending}
                    width={600}
                >
                    <p style={{ marginBottom: 8 }}>回复内容（纯文本）：</p>
                    <Input.TextArea
                        rows={16}
                        value={this.state.replyBody}
                        onChange={e => this.setState({ replyBody: e.target.value })}
                        placeholder="请输入回复内容..."
                        maxLength={10000}
                    />
                    {this.state.replyImagePaths && this.state.replyImagePaths.length > 0 && (
                        <>
                            <p style={{ marginTop: 12, marginBottom: 8 }}>附件图片：</p>
                            <Image.PreviewGroup>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                    {this.state.replyImagePaths.map((url, i) => (
                                        <Image
                                            key={i}
                                            src={buildShortProductImageUrl(url)}
                                            width={60}
                                            height={60}
                                            style={{ objectFit: 'cover', borderRadius: '4px', border: '1px solid #d9d9d9' }}
                                            preview={{ src: buildShortProductImageUrl(url) }}
                                        />
                                    ))}
                                </div>
                            </Image.PreviewGroup>
                        </>
                    )}
                </Modal>

                {/* 邮件预览弹窗 */}
                <Modal
                    title="邮件预览"
                    open={this.state.previewModalVisible}
                    onCancel={() => this.setState({ previewModalVisible: false })}
                    footer={null}
                    width={700}
                >
                    <Spin spinning={this.state.previewLoading}>
                        {this.state.previewMail ? (
                            <div>
                                <p><strong>标题:</strong> {this.state.previewMail.subject}</p>
                                <p><strong>发件人:</strong> {this.state.previewMail.from?.name} &lt;{this.state.previewMail.from?.address}&gt;</p>
                                <p><strong>时间:</strong> {this.state.previewMail.received_at}</p>
                                <hr />
                                <div
                                    style={{ maxHeight: 400, overflow: 'auto' }}
                                    dangerouslySetInnerHTML={{
                                        __html: this.state.previewMail.body?.content_type === 'html'
                                            ? this.state.previewMail.body?.content
                                            : '<pre>' + (this.state.previewMail.body?.content || '') + '</pre>'
                                    }}
                                />
                            </div>
                        ) : (
                            !this.state.previewLoading && <p>未找到匹配邮件</p>
                        )}
                    </Spin>
                </Modal>
            </>
        );
    }
}

export default ShortProductTable;
